import { useEffect, useState } from "react";
import "./InstagramGallery.css";

const PROFILE_URL = "https://www.instagram.com/jasminelandscapedesign/?hl=en";

const InstagramGallery = () => {
  const [photos, setPhotos] = useState([]);
  const [status, setStatus] = useState("loading"); // loading | ready | error

  useEffect(() => {
    let cancelled = false;

    fetch("/.netlify/functions/instagram-photos")
      .then((res) => {
        if (!res.ok) throw new Error("Instagram feed unavailable");
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        setPhotos(data.photos || []);
        setStatus("ready");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // If the feed can't load (not set up yet, token expired, offline), fail
  // quietly to a plain link instead of showing a broken grid to visitors.
  if (status === "error" || (status === "ready" && photos.length === 0)) {
    return (
      <div className="InstagramGallery-fallback">
        <a href={PROFILE_URL} target="_blank" rel="noopener noreferrer">
          See our latest projects on Instagram
        </a>
      </div>
    );
  }

  return (
    <div className="InstagramGallery-container">
      <h2 className="InstagramGallery-heading">Latest From Instagram</h2>
      <a
        className="InstagramGallery-handle"
        href={PROFILE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        @jasminelandscapedesign
      </a>

      <div className="InstagramGallery-grid">
        {status === "loading"
          ? Array.from({ length: 8 }).map((_, idx) => (
              <div key={idx} className="InstagramGallery-skeleton" />
            ))
          : photos.map((photo) => (
              <a
                key={photo.id}
                href={photo.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="InstagramGallery-item"
              >
                <img src={photo.image} alt={photo.caption ? photo.caption.slice(0, 120) : "Instagram post"} />
              </a>
            ))}
      </div>
    </div>
  );
};

export default InstagramGallery;
